import initStatisticAnimation from "../StatisticAnimation/initStatisticAnimation.js";
import scrollama from "scrollama";

export default function initContainers() {
  //select only top level containers
  const containerEls = document.querySelectorAll(
    ".main-content-wrapper > .js-container",
  );

  if (containerEls) {
    containerEls.forEach((el, i) => {
      const scroller = scrollama();

      scroller.setup({ step: el, once: true, offset: 0.6 }).onStepEnter(() => {
        //add modifier class for css animations
        el.classList.add("container--in-view");

        //trigger statistic animations
        const statisticAnimationEls = el.querySelectorAll(
          ".js-statistic-animation",
        );

        if (statisticAnimationEls) {
          statisticAnimationEls.forEach((el, j) => {
            initStatisticAnimation(el);
          });
        }
      });

      window.addEventListener("resize", scroller.resize);
      window.addEventListener("load", scroller.resize);
    });
  }
}
